var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailInterfaceIconSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -15.4 108.5 108.5",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_blackgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-278.6 -471.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M371.9,473.2H293.8a13.187,13.187,0,0,0-13.2,13.2v47.3a13.187,13.187,0,0,0,13.2,13.2h78.1a13.187,13.187,0,0,0,13.2-13.2V486.4A13.317,13.317,0,0,0,371.9,473.2Z",
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M282.1,488.2l51.1,21.9,25.2-10.8",
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M374,490.7a4.331,4.331,0,0,1-5,5,4.241,4.241,0,0,1-3.6-3.6,4.331,4.331,0,0,1,5-5A4.241,4.241,0,0,1,374,490.7Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 19.5,
    y2: 19.8,
    transform: "translate(287.4 524)",
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 19.5,
    y2: 19.8,
    transform: "translate(358.7 524)",
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailInterfaceIconSvgrepoCom);
export default __webpack_public_path__ + "static/media/email-interface-icon-svgrepo-com.a0a27f7c86aaa1b0d69e4f53fdcd2910.svg";
export { ForwardRef as ReactComponent };